import { render, staticRenderFns } from "./ReceiptPdfSettingsDialog.vue?vue&type=template&id=af538a36&scoped=true"
import script from "./ReceiptPdfSettingsDialog.vue?vue&type=script&lang=js"
export * from "./ReceiptPdfSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./ReceiptPdfSettingsDialog.vue?vue&type=style&index=0&id=af538a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af538a36",
  null
  
)

export default component.exports